// extracted by mini-css-extract-plugin
export var hidden = "_4j-1";
export var leftPanel = "_4j-2";
export var readonlyInspector = "_4j-3";
export var rightPanel = "_4j-0";